import { getSmartDefaults, getProductsEditDefaultsUrl, PRODUCTS_SMART_DEFAULTS_PATH } from '../../utils/smartDefaults';

const PRODUCTS_DEFAULTS_PATH = PRODUCTS_SMART_DEFAULTS_PATH;
const PRODUCTS_EDIT_DEFAULTS_PATH = getProductsEditDefaultsUrl();

export const getEstimatedBadgeTooltip = (metricKey, defaults = getSmartDefaults()) => {
    switch (metricKey) {
        case 'net_profit':
            return {
                title: 'Estimated net profit',
                body: 'This take-home figure leans on default COGS, returns and GST - not your real per-SKU costs - so it could be over- or under-stated.',
            };
        case 'gross_profit':
            return {
                title: 'Estimated gross profit',
                body: 'This margin figure uses default COGS and return assumptions - not your real per-SKU costs - so it could be over- or under-stated.',
            };
        case 'cost_of_goods':
            return {
                title: 'Estimated cost of goods sold',
                body: `COGS is calculated at ${defaults.cogsPercentOfPrice}% of selling price until you set per-SKU costs on Products.`,
            };
        case 'refund_cost':
            return {
                title: 'Estimated refund cost',
                body: `Unsellable returns are assumed at ${defaults.unsellableReturnsPercent}% until you customize values per product.`,
            };
        case 'net_tax':
            return {
                title: 'Estimated net tax (GST)',
                body: `Tax uses default rates (${defaults.taxCollectedOnSalesPercent}% collected, ${defaults.taxPaidOnCogsPercent}% on COGS) until you set per-SKU tax on Products.`,
            };
        default:
            return {
                title: 'Estimated value',
                body: 'This figure uses smart defaults — not your real per-SKU costs — so it could be over- or under-stated.',
            };
    }
};

export { PRODUCTS_DEFAULTS_PATH, PRODUCTS_EDIT_DEFAULTS_PATH };
